/* eslint-disable no-console */
import React from "react";
import { useDispatch } from "react-redux";
import { PlusOutlined } from "@ant-design/icons";
import { Button, Input } from "../../atoms";
import { openModal } from "../../../redux/data/modals/modalReducer";
import { PageToolbar } from "../../molecules";

interface IAgentListToolbarProps {
  searchName: string;
  onSearchNameChange: (value: string) => void;
}

export const AgentListToolbar: React.FC<IAgentListToolbarProps> = ({
  searchName,
  onSearchNameChange,
}) => {
  const dispatch = useDispatch();

  const handelAddBoard = () => {
    dispatch(
      openModal({
        modalType: "AddAgentModal",
        modalProps: { title: "Add Agent Form" },
      })
    );
  };

  return (
    <PageToolbar>
      <Button
        type="primary"
        onClick={handelAddBoard}
        block
        icon={<PlusOutlined />}
        className="page-toolbar-btn"
      >
        Add Agent
      </Button>

      <div className="page-toolbar-right-children-elements">
        <Input.Search
          placeholder="Search by agent name"
          allowClear
          value={searchName}
          onChange={(e) => onSearchNameChange(e.target.value)}
          style={{ width: 320 }}
        />
      </div>
    </PageToolbar>
  );
};
